import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { adapter } from "@/services/db";
import { useAuth } from "@/context/AuthContext";
import { logEdit } from "@/components/explorer/audit";
import { nowLike } from "@/components/crm/InlineEdit";

import { MILESTONE_STATUSES as MS, MILESTONE_PAYMENT_STATUSES, labelOf } from "@/lib/fieldEnums";

// Same vocabulary Brugo Pro / Brugo Web write (see lib/fieldEnums.js); legacy values still selectable.
export const MILESTONE_STATUSES = MS;
export const PAYMENT_STATUSES = MILESTONE_PAYMENT_STATUSES;

// Inline status editor for one project_milestones doc (audited).
export function MilestoneStatusSelect({ m, field = "status", options = MILESTONE_STATUSES }) {
  const { user } = useAuth();
  const opts = Array.from(new Set([...(m[field] ? [m[field]] : []), ...options]));
  const change = async (v) => {
    try {
      await adapter.update("project_milestones", m.id, { [field]: v, updated_at: nowLike(m.updated_at) });
      await logEdit(user, { path: "project_milestones", id: m.id, action: "update_field", field, before: m[field], after: v, sensitive: false });
      toast.success(`${m.title || "Milestone"} · ${field} → ${v}`);
    } catch (e) { toast.error(e.code === "permission-denied" ? "Permission denied by Firestore rules" : e.message); }
  };
  return (
    <Select value={m[field] || ""} onValueChange={change}>
      <SelectTrigger className="h-7 w-36 text-[11px]" data-testid={`ms-${field}-${m.id}`}><SelectValue placeholder={field} /></SelectTrigger>
      <SelectContent>{opts.map((o) => <SelectItem key={o} value={o} className="text-xs">{labelOf(o)}</SelectItem>)}</SelectContent>
    </Select>
  );
}
